import store from '../../store'

// Utilities
import Preference from '../../utility/preferenceUtil'

import { KeyConstants } from '../../constants'
import { defaultObj } from './state'

export default {
  setOffers (state, offers) {
    if (Array.isArray(offers)) {
      state.offers = offers
    }
  },

  setUnviewedOffersCount (state, unviewedOffersCount) {
    state.unviewedOffersCount = unviewedOffersCount
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
    Preference.delete(KeyConstants.viewedOfferIds)
    store.cache.delete('offers/getOffers')
  }
}
